import React from 'react';
import { Grid, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { IPurchaserInfo } from '../../types/CreateDealForm';
const AssignmentCard = ({ assignment }: any) => {
  return (
    <>
      <Grid item lg={2} md={4} sm={6} xs={12}>
        <Link style={{ textDecoration: 'none' }} to={`/${assignment.project._id}/dashboard/${assignment.unit._id}`}>
          <Paper
            elevation={12}
            sx={{
              p: 2,
              width: '100%',
              position: 'relative',
              transition: 'transform 0.5s ease-in-out',
              '&:hover': {
                transform: 'scale(1.03)',
              },
              backgroundColor: 'red',
              cursor: 'pointer',
            }}
          >
            <strong>Suite {assignment.unit.suite}</strong>
            <div style={{ fontSize: '12px' }}>{assignment.assigneesRealtor ? assignment.assigneesRealtor.fullName : null}</div>
            <div style={{ fontSize: '12px' }}>
              Assignees: {assignment.assignees.map((assignee: IPurchaserInfo) => assignee.fullName).join(', ')}
            </div>
          </Paper>
        </Link>
      </Grid>
    </>
  );
};

export default AssignmentCard;
